module.exports = __webpack_public_path__ + "img/o-taiwan.042dc8b7.png";